module.exports = ".footer-space-fix{\n  height: 100px;\n}\n\n:host{\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n}\n"